export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';

export const setEnvironmentAction = (environment) => ({
  type: SET_ENVIRONMENT,
  payload: environment,
}); 